import { memo } from 'react';
import { Field } from 'react-final-form';
import { mergeInputProps } from '@dnhb/functional-final-form';
import { FieldInputProps } from './types';
import Input, { InputProps } from '../Input';

export type Props = InputProps & FieldInputProps<string>;

const InputField = memo<Props>((props) => (
  <Field<string>
    validateFields={[]}
    {...props}
    render={({ input, meta }) => {
      const errors = [meta.error, meta.submitError, props.errors]
        .filter((error) => Array.isArray(error))
        .flat();
      return (
        <Input
          {...mergeInputProps(input, props)}
          errors={
            errors.length && (!meta.submitError || !meta.dirtySinceLastSubmit)
              ? errors
              : null
          }
        />
      );
    }}
  />
));

export default InputField;
